import { apiPost } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IQuestionHighlight, ICreateHighlightRequest } from "./types";

/**
 * 문제 하이라이트 저장 API 함수
 * @param data 하이라이트 데이터 (exam_progress_id, question_id 또는 passage_id 포함)
 * @returns API 응답
 */
export const apiSaveHighlights = async (data: ICreateHighlightRequest) => {
  // question_id 또는 passage_id 중 하나는 반드시 있어야 함
  if (!data.question_id && !data.passage_id) {
    throw new Error("Either question_id or passage_id must be provided");
  }

  const response = await apiPost<IQuestionHighlight>(`/highlights`, data);
  return response;
};

/**
 * 문제 하이라이트 저장 React Query 훅
 * @returns 뮤테이션 객체
 */
export const useSaveHighlights = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ICreateHighlightRequest) => apiSaveHighlights(data),
    onSuccess: (response, variables) => {
      // 해당 문제의 하이라이트 정보 갱신
      if (variables.passage_id) {
        queryClient.invalidateQueries({
          queryKey: [
            ...QueryKeys.question.all,
            "highlights",
            variables.exam_progress_id,
            "passage",
            variables.passage_id,
          ],
        });
      } else if (variables.question_id) {
        queryClient.invalidateQueries({
          queryKey: [
            ...QueryKeys.question.all,
            "highlights",
            variables.exam_progress_id,
            "question",
            variables.question_id,
          ],
        });
      }
    },
  });
};

export default useSaveHighlights;
